import React from 'react';
import { Portal } from 'react-portal';

import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

import './Overlay.css';

const stopPropagation = e => e.stopPropagation();

const FULL_OVERLAY_STYLES = {
  closeButton: {
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
    width: 32,
    height: 32,
    margin: 16,
    padding: 0,
    borderRadius: 16
  }
};

class Overlay extends React.Component {
  componentDidMount() {
    const body = this.getBody();
    if (body && body.classList) {
      body.classList.add('with-overlay');
    }
  }

  componentWillUnmount() {
    const body = this.getBody();
    if (body && body.classList) {
      body.classList.remove('with-overlay');
    }
  }

  getBody = () => document.body || document.getElementsByTagName('body')[0];

  render() {
    const { children, full } = this.props;
    const { onRequestClose } = this.props;
    return (
      <Portal>
        <div className={`overlay-container${full ? ' full' : ''}`} onClick={onRequestClose}>
          <div className="overlay-container-close-button-container">
            <IconButton onClick={onRequestClose} style={full ? FULL_OVERLAY_STYLES.closeButton : {}}>
              <CloseIcon color={full ? 'white' : 'rgba(33,33,33,0.87)'} />
            </IconButton>
          </div>
          {full ? (
            <div className="overlay-content-container" onClick={stopPropagation}>
              {children}
            </div>
          ) : (
            <div className="container" style={{ maxWidth: '960px' }}>
              <div className="overlay-content-container" onClick={stopPropagation}>
                {children}
              </div>
            </div>
          )}
        </div>
      </Portal>
    );
  }
}

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/basic/Overlay.js